import { useEffect, useState } from 'react';
import { listSupplierPortfolio } from '../lib/api';

/**
 * Best-effort supplier portfolio count for the OrgShell sidebar badge.
 * Never blocks first paint; failures leave the count at 0.
 *
 * V3-8-8: Uses the lightweight `listSupplierPortfolio` endpoint which
 * returns the portfolio array — `.length` gives us the total without a
 * dedicated count endpoint.
 */
export function useOrgSupplierCount(orgSlug: string | undefined): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!orgSlug) {
      setCount(0);
      return;
    }
    let cancelled = false;
    listSupplierPortfolio(orgSlug).then(
      (r) => {
        if (!cancelled) setCount(r.portfolio.length);
      },
      () => {
        /* swallow — badge is best-effort */
      },
    );
    return () => {
      cancelled = true;
    };
  }, [orgSlug]);
  return count;
}
